const Sorteador = () => {
  const url = "https://firebasestorage.googleapis.com/v0/b/igrejasaopedroapp.appspot.com/o/page%2Fsorteador.html?alt=media&token=29bd326f-03a9-452a-918c-a073b9802a42";

  return (<></>
    // <iframe
    //   src={url}
    //   title="Sorteador"
    //   style={{
    //     position: "fixed",
    //     top: 0,
    //     left: 0,
    //     width: "100vw",
    //     height: "100vh",
    //     border: "none",
    //     zIndex: 9999
    //   }}
    // />
  );
};


export default Sorteador;